import { hideSnackbar, showSnackbar as commonShowSnackbar } from './common';

export const showSnackbar = (dispatch, msg, typesError = "error", timeout = 3000) => {
  dispatch(commonShowSnackbar(msg, typesError));
  setTimeout(() => {
    dispatch(hideSnackbar());
  }, timeout);
}